import React, {useEffect, useContext} from 'react';
import "../../assets/OD_UFL_4/scss/main.scss"
import Logo from '../../assets/OD_UFL_4/img/logo-white.png';
import Thankyou from '../../assets/OD_UFL_4/img/thankyou.gif';
import Footer from '../Includes/Layouts/OD_UFL_4/Footer'
import { useUpdateMilestone } from '../../Hooks/useUpdateMilestone';
import VisitorParamsContext from "../../Contexts/VisitorParams";
import QueryStringContext from "../../Contexts/QueryString";
import { usePageLoad } from "../../Hooks/usePageLoad";
import { getPageName } from "../../Constants/PageNames";


const ThankyouFlps = ({}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const uuid = urlSearchParams.get('uuid');
  const { updateMilestone } = useUpdateMilestone();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { queryString } = useContext(QueryStringContext);
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem('split_name');
  useEffect(() => {
    const allFollowupData = JSON.parse(localStorage.getItem('allFollowupData'));
        if (allFollowupData) {
            let flp_source = allFollowupData.atp_sub6;
            updateMilestone(uuid, "completed", flp_source);
        }
        else {
            updateMilestone(uuid, "completed", "FLP");
        }
    // localStorage.clear();
  }, []);

  useEffect(() => {
    const allFollowupData = JSON.parse(localStorage.getItem('allFollowupData'));
              if (!!uuid && !calledOnce) {
              const data = {
                  uuid,
                  page_name: getPageName("thankyou_flp_reconfirm_sign"),
                  status: "visited",
                  source: allFollowupData?.atp_sub6 ?? "regular",
              };
              (async () => {
                  await savePageLoad(
                  visitorParameters.visitor_parameters,
                  data,
                  "visited_status",
                  splitName,
                  queryString,
                  visitorParameters.data
                  );
                  localStorage.clear();
              })();
              }
          }, [uuid, calledOnce]);
    return (
        <>
            <div className='OD_UFL_4'>
                <section className="banner qs-section">
                    <div className="container">
                        <div>
                            <div className="brand">
                                <div className="logo pt-3 text-center">
                                    <a href="index.html"> <img src={Logo} height={60} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="mt-5 text-center pt-5">
                            <div className="mb-0 mt-5">
                                <img src={Thankyou} height={150}  />
                            </div>
                            <h1 className="text-white">Thank you</h1>
                            <p className="text-white">We will get in touch with you shortly
                            </p>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>


        </>
    )
}

export default ThankyouFlps;